const filesystemConfig = {
  THUMBNAIL_WIDTH: 128,
  THUMBNAIL_HEIGHT: 141,
  TILE_WIDTH: 200,
  TILE_HEIGHT: 52,
  ICON_WIDTH: 75,
  ICON_HEIGHT: 63,
  LIST_HEIGHT: 16,
  DISK_HEADER_HEIGHT: 26
};

export default filesystemConfig;
